import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { UserService } from '../../core/services/user.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

const SESSION_KEY = 'staff_select_studio_id';

@Component({
    selector: 'app-staff-list',
    imports: [RouterLink, FormsModule, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
    </div>
    <div class="card-body">
      <!-- 旧版 staff.html:11-13 の card-body 先頭 <flash-message> 相当 -->
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label" for="studio_name">店舗</label>
                <select class="form-control" id="studio_name" [(ngModel)]="selectedStudio"
                  name="studio_name" (ngModelChange)="onStudioChange()">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (studio of studios; track studio.id) {
                    <option [ngValue]="studio">{{ studio.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
        @if (showFilterOption) {
          <div class="row" style="align-items: flex-end;">
            <div class="col-md-8">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [ngModel]="keyword" (ngModelChange)="keyword = $event; pageIndex = 0"
                    class="form-control" placeholder="従業員名など">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <button class="btn btn-warning text-white" type="button" (click)="keyword=''; pageIndex=0">
                    <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row mb-3">
        <div class="col-md-12">
          <a class="btn btn-primary text-white" routerLink="/staff/new">
            <i class="fa s-icon-plus"></i>&nbsp;新規作成
          </a>
        </div>
      </div>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (selectedStudio && !searching && filteredItems.length === 0) {
        <span>該当するデータはありません</span>
      }
      @if (filteredItems.length > 0) {
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        <table class="table table-bordered table-sm table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">状態</th>
              <th>企業名</th>
              <th>店舗名</th>
              <th>従業員名</th>
              <th>メールアドレス</th>
              <th width="10%"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td class="text-center">
                  @if (item.user?.status === 0) {
                    <button class="btn text-green p-0 bg-inherit active" type="button" (click)="setStatus(item, 1)">
                      <i class="fa fa-3x fa-toggle-on"></i>
                    </button>
                  } @else {
                    <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="setStatus(item, 0)">
                      <i class="fa fa-3x fa-toggle-off"></i>
                    </button>
                  }
                </td>
                <td>{{ item.studio?.owner?.name }}</td>
                <td>{{ item.studio?.name }}</td>
                <td>{{ item.user?.name }}</td>
                <td>{{ item.user?.email }}</td>
                <td class="text-center">
                  <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                    [routerLink]="['/staff/edit', item.user?.id]" title="編集">
                    <i class="fa s-icon-edit fa-fw"></i>
                  </a>
                  @if (item.user?.status === 0) {
                    <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled title="削除">
                      <i class="fa s-icon-delete fa-fw"></i>
                    </button>
                  } @else {
                    <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" (click)="openDeleteModal(item.user)" title="削除">
                      <i class="fa s-icon-delete fa-fw"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
      }
    </div>
  </div>
  @if (showDeleteModal) {
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content border-danger">
          <div class="modal-header bg-danger">
            <h5 class="modal-title"> 従業員の削除</h5>
            <button type="button" class="close" (click)="showDeleteModal = false">
              <span class="text-white" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #FFF6F8 !important">
            <div class="form-group row">
              <label class="col-md-12 col-form-label">従業員を削除します。よろしいですか。</label>
            </div>
          </div>
          <div class="modal-footer" style="background-color: #FFF6F8 !important">
            <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            <button class="btn btn-danger" type="button" (click)="doDelete()">
              <i class="fa s-icon-delete"></i>&nbsp;削除
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
  `
})
export class StaffListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private userService = inject(UserService);
  private studioSelection = inject(StudioSelectionService);

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  keyword = '';
  private loadRevision = 0;
  searching = false;
  readonly pageLimit = 100;
  pageIndex = 0;
  showDeleteModal = false;
  selectedUser: any = null;

  get showFilterOption(): boolean { return !!this.selectedStudio; }

  get filteredItems(): any[] {
    return this.items.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      await this.loadStaff();
    }
  }

  async onStudioChange(): Promise<void> {
    ++this.loadRevision;
    this.pageIndex = 0;
    this.items = [];
    this.searching = false;
    if (!this.selectedStudio) { this.studioSelection.clear(SESSION_KEY); return; }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.loadStaff();
  }

  private async loadStaff(): Promise<void> {
    const revision = ++this.loadRevision;
    if (!this.selectedStudio) return;
    this.searching = true;
    try {
      const items = await this.studioService.getStaff(this.selectedStudio.id) ?? [];
      if (revision !== this.loadRevision) return;
      this.items = items;
    } finally {
      if (revision === this.loadRevision) this.searching = false;
    }
  }

  async setStatus(item: any, status: number): Promise<void> {
    await this.userService.upsert({ id: item.user.id, status });
    if (item.user) item.user.status = status;
  }

  openDeleteModal(user: any): void {
    this.selectedUser = user;
    this.showDeleteModal = true;
  }

  doDelete(): void {
    this.showDeleteModal = false;
    this.userService.remove(this.selectedUser.id).then(() => {
      this.items = this.items.filter(i => i.user?.id !== this.selectedUser.id);
      this.goToPage(this.pageIndex);
    });
  }
}
